<template>
  <div class="collgoods">
    <nav class="robbing-nav">
      <div class="robbing-nav-item" :class="{ select: statusType == 'ing' }" @click="toggleType('ing')">
        待取件
      </div>
      <div class="robbing-nav-item" :class="{ select: statusType == 'complete' }" @click="toggleType('complete')">
        已签收
      </div>
      <div class="robbing-nav-item" :class="{ select: statusType == 'toreturn' }" @click="toggleType('toreturn')">
        待退送
      </div>
      <div class="robbing-nav-item" :class="{ select: statusType == 'returned' }" @click="toggleType('returned')">
        已退送
      </div>
    </nav>
    <section class="mail-tips" v-if="statusType == 'toreturn' || statusType == 'returned'">
      <span style="font-size: 14px; font-weight: bold">温馨提示</span>
      <p style="font-size: 12px">超过3天未取的快递将被原路退回寄件方。</p>
    </section>
    <section class="collgoods-main">
      <div class="empty-data" v-if="!haveData">
        <div>
          <i class="iconfont icon-similarproduct"></i>
        </div>
        <div>
          <p>暂无数据</p>
        </div>
      </div>
      <div class="collgoods-item" v-for="item in expresses" :key="item._id">
        <div class="collgoods-item-top">
          <div class="item-top-left">
            <i class="iconfont icon-kuaidiyuan-xianxing" aria-hidden="true"></i>
            <span>{{ item.expressCompany.name }}</span>
          </div>
          <div class="item-top-right">
            <a href="javascript:;">{{ item.statusStr }}</a>
          </div>
        </div>
        <div class="collgoods-item-middle">
          <div class="item-middle-left">
            <p>
              <span class="item-middle-left_title">快递单号：</span>
              <span>{{ item.expressNo }}</span>
            </p>
            <p v-if="item.type != 2 && item.type != 3">
              <span class="item-middle-left_title">收件联系：</span>
              <span>{{ item.receiver }}</span>
            </p>
            <p v-else>
              <span class="item-middle-left_title">柜机地址：</span>
              <span>{{ item.deviceAddress }}</span>
            </p>
            <p v-if="item.type != 2 && item.type != 3">
              <span class="item-middle-left_title">收件电话：</span>
              <span>{{ item.receiverPhone }}</span>
            </p>
            <p v-else-if="item.type == 2">
              <span class="item-middle-left_title">所在柜号：</span>
              <span>{{
              item.storageNo && item.storageNo != "默认"
              ? item.storageNo + "号柜-" + item.tag
              : "--"
              }}</span>
            </p>
            <p v-else-if="item.type == 3">
              <span class="item-middle-left_title">所在柜号：</span>
              <span>{{
              item.storageNo && item.storageNo != "默认"
              ? item.storageNo + "-" + item.tag
              : "--"
              }}</span>
            </p>
            <p v-if="item.type != 2 && item.type != 3">
              <span class="item-middle-left_title">取件编码：</span>
              <span v-if="item.safekeepNeedPay && !item.isPayed">
                <font class="password">支</font>
                <font class="password">付</font>
                <font class="password">后</font>
                <font class="password">显</font>
                <font class="password">示</font>
              </span>
              <span v-else>{{ item.storageNo }}-{{ item.tag }}</span>
            </p>
            <p v-else-if="item.status != 100 && item.status != 400">
              <span class="item-middle-left_title">取件密码：</span>
              <span>{{ item.password }}</span>
            </p>
          </div>
          <div class="item-middle-right" v-if="item.safekeepNeedPay && !item.isPayed" @click="goPay(item)">
            <div class="open-bnt">支付</div>
          </div>
          <div class="item-middle-right" v-else-if="
            item.status != 100 && item.status != 400 && item.type == 2
          " @click="showImagePreview(item.qrcode)">
            <img :src="item.qrcode" />
          </div>
          <div class="item-middle-right" v-else-if="
            item.type == 3 && item.status != 100 && item.status != 400
          " @click="openBox(item._id)">
            <div class="open-bnt">开柜</div>
          </div>
        </div>
        <div class="item-middle-left" style="border-bottom: 1px solid #ccc; color: red; font-weight: bold"
          v-if="item.agent && item.receiverOpenid == userInfo.openid">
          <p>
            <span class="item-middle-left_title">代取朋友：</span>
            <span>{{ item.agent }}</span>
            <a :href="'tel:' + item.agentPhone" style="color: blue">
              <i class="iconfont icon-mobilephone"></i>
            </a>
          </p>
        </div>
        <div class="item-middle-left" style="border-bottom: 1px solid #ccc; color: red; font-weight: bold"
          v-if="item.paotuiOrderNo">
          <p>
            <span class="item-middle-left_title">跑腿单号：</span>
            <span>{{ item.paotuiOrderNo }}</span>
          </p>
        </div>
        <div class="item-middle-left" style="border-bottom: 1px solid #ccc; color: red; font-weight: bold"
          v-if="item.paotuiName">
          <p>
            <span class="item-middle-left_title">校园跑腿：</span>
            <span>{{ item.paotuiName }}</span>
            <a :href="'tel:' + item.paotuiPhone" style="color: blue">
              <i class="iconfont icon-mobilephone"></i>
            </a>
          </p>
        </div>
        <div class="collgoods-item-bottom" v-if="item.status != 100 && item.status != 300 && item.status != 400">
          <!-- <div class="collgoods-item-bottom-left">
            <i class="iconfont icon-daxiao" aria-hidden="true"></i>
            <span>{{ item.sizeStr }}</span>
          </div> -->
          <div class="collgoods-item-bottom-right" v-if="
            item.status == 0 &&
            (!item.safekeepNeedPay || (item.safekeepNeedPay && item.isPayed))
          ">
            <a href="javascript:;" class="yiqu" v-if="selfSignAble" @click="yiqu(item._id)">已取</a>
            <!-- <a href="javascript:;" class="daiqu" @click="daiqu(item._id)">朋友代取</a> -->
            <a href="javascript:;" class="songhuo" @click="songhuo(item._id)" v-if="
              userInfo.worksite &&
              userInfo.worksite.paotuiAble &&
              (!item.safekeepNeedPay ||
                (item.safekeepNeedPay && item.isPayed))
            ">送件上门</a>
          </div>
          <!-- <div class="collgoods-item-bottom-right" v-if="item.status==1">
            <a
              href="javascript:;"
              class="daiqu"
              @click="jujue(item)"
              v-if="item.receiverOpenid!=userInfo.openid"
            >拒绝代取</a>
            <a
              href="javascript:;"
              class="daiqu"
              @click="quxiao(item)"
              v-if="item.receiverOpenid==userInfo.openid"
            >取消代取</a>
          </div> -->
          <div class="collgoods-item-bottom-right" v-if="item.status != 0 && item.status != 1 && item.status != 100">
            <a href="javascript:;" class="zhifu" @click="zhifu(item)" v-if="item.status == 2">预付赏金</a>
            <a href="javascript:;" class="daiqu" @click="quxiaopaotui(item)"
              v-if="item.status == 2 || item.status == 3">取消跑腿</a>
            <a href="javascript:;" class="songhuo" @click="qianshou(item._id, item.paotuiOrderNo)"
              v-if="item.status == 5 || item.status == 6">确认签收</a>
          </div>
        </div>
      </div>
    </section>

    <div v-infinite-scroll="loadMore" infinite-scroll-disabled="isScrollBusy" infinite-scroll-distance="30">
      <div align="center" style="margin-top: 10px; margin-bottom: 10px">
        <cube-loading style="width: 24px" v-if="isScrollBusy && !isScrollEnd" />
        <span style="color: #999999; font-size: 0.8rem" v-else-if="isScrollEnd && haveData">没有更多了</span>
      </div>
    </div>
  </div>
</template>
<script>
import config from "../config/config.js";
import weui from "weui.js";
import axios from "axios";
import moment from "moment";
import io from "socket.io-client";
const wx = require("weixin-js-sdk");

export default {
  data() {
    return {
      encodeToken: "",
      token: "",
      selfSignAble: true,
      haveData: true,
      statusType: "",
      year: moment().format("YYYY"),
      expresses: [],
      userInfo: {},
      imgPreivew: null,
      imgs: [],
      isScrollBusy: false,
      isScrollEnd: false,
      pageNo: 0,
      pageCount: 0,
      recordCount: 0,
    };
  },
  created() {
    let that = this;
    this.statusType = this.$route.params.status;
    this.encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(this.encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;

    let url = window.location.href;
    let params = {
      url: url,
    };
    let jsConfig = {};
    axios
      .get("/api/wx/jsconfig", { params })
      .then((res) => {
        jsConfig = res.data.data;
        jsConfig.jsApiList = ["chooseWXPay"];
        wx.config(jsConfig);
      })
      .catch((err) => {
        console.log(err);
        this.haveData = false;
      });

    // 根据token查找微信用户信息
    axios
      .get("/api/user/wxuserInfoForTotakeList")
      .then((response) => {
        this.userInfo = response.data.data;
        this.selfSignAble = this.userInfo.worksite.selfSignAble;
        const socket = io(config.socket, {
          transports: ["websocket"],
        });
        // 建立 socket 连接
        socket.on("connect", function () {
          console.log("socket.io connect...");
        });
        socket.on("reconnect_attempt", () => {
          socket.io.opts.transports = ["websocket", "polling"];
        });
        socket.on(
          "takeawaySuccess-" + this.userInfo.openid,
          function (expressId) {
            if (that.statusType == "ing") {
              for (let i = 0; i < that.expresses.length; i++) {
                if (that.expresses[i]._id == expressId) {
                  that.expresses.splice(i, 1);
                  if (that.imgPreivew) {
                    that.imgPreivew.hide();
                  }
                  if (that.pageNo < that.pageCount) {
                    that.loadMore();
                  }
                  break;
                }
              }
              if (that.expresses.length == 0) {
                that.haveData = false;
              }
            }
          }
        );
        socket.on(this.userInfo.openid + "-agentAdd", function (item) {
          // 处于待取件页签才需要响应
          if (that.statusType == "ing") {
            that.haveData = true;
            if (item.safekeepNeedPay && !item.isPayed) {
              item.statusStr = "待支付";
            } else {
              item.statusStr = "朋友代取";
            }
            item.inTime = moment(item.createdAt).format("YYYY-MM-DD HH:mm");
            item.qrcode = "data:image/png;base64," + item.agentQrimgBase64;
            that.expresses.unshift(item);
          }
        });
        socket.on(this.userInfo.openid + "-expressTotakeAdd", function (item) {
          // 处于待取件页签才需要响应
          if (that.statusType == "ing") {
            that.haveData = true;
            if (item.safekeepNeedPay && !item.isPayed) {
              item.statusStr = "待支付";
            } else {
              item.statusStr = "待取件";
            }
            item.inTime = moment(item.createdAt).format("YYYY-MM-DD HH:mm");
            item.qrcode = "data:image/png;base64," + item.qrimgBase64;
            that.expresses.unshift(item);
          }
        });
        /**
         * 已完成取件
         * 如果在待取件页面，则需要删除该记录
         * 如果在已签收页面，则需要新增该记录
         */
        socket.on(this.userInfo.openid + "-expressSended", function (item) {
          if (that.statusType == "ing") {
            for (let i = 0; i < that.expresses.length; i++) {
              if (that.expresses[i]._id == item._id) {
                that.expresses.splice(i, 1);
                if (that.imgPreivew) {
                  that.imgPreivew.hide();
                }
                break;
              }
            }
            if (that.expresses.length == 0) {
              that.haveData = false;
            }
          } else if (that.statusType == "complete") {
            that.haveData = true;
            item.statusStr = "已签收";
            item.inTime = moment(item.createdAt).format("YYYY-MM-DD HH:mm");
            that.expresses.unshift(item);
          }
        });
        socket.on("paotuiSayReceiverGet", function (_id) {
          // 处于待取件页签才需要响应
          if (that.statusType == "ing") {
            for (let i = 0; i < that.expresses.length; i++) {
              if (that.expresses[i]._id == _id) {
                that.expresses[i].status = 6;
                that.expresses[i].statusStr = "已送达";
              }
            }
          }
        });
        socket.on("expressTosendPaotuiSign", function (_id) {
          // 处于待取件页签才需要响应
          if (that.statusType == "ing") {
            for (let i = 0; i < that.expresses.length; i++) {
              if (that.expresses[i]._id == _id) {
                that.expresses[i].status = 5;
                that.expresses[i].statusStr = "已领货";
              }
            }
          }
        });
        socket.on("paotuiOrderRobbinged", function (item) {
          // 处于待取件页签才需要响应
          if (that.statusType == "ing") {
            for (let i = 0; i < that.expresses.length; i++) {
              if (that.expresses[i]._id == item._id) {
                that.expresses[i].status = 4;
                that.expresses[i].statusStr = "已领任务";
                that.expresses[i].paotuiName = item.paotuiName;
                that.expresses[i].paotuiPhone = item.paotuiPhone;
              }
            }
          }
        });
        socket.on("paotuiOrderCancel", function (_id) {
          // 处于待取件页签才需要响应
          if (that.statusType == "ing") {
            for (let i = 0; i < that.expresses.length; i++) {
              if (that.expresses[i]._id == _id) {
                that.expresses[i].status = 0;
                that.expresses[i].statusStr = "待取件";
                that.expresses[i].paotuiOrderNo = "";
                that.expresses[i].paotuiName = "";
                that.expresses[i].paotuiOpenid = "";
                that.expresses[i].paotuiPhone = "";
              }
            }
          }
        });
        socket.on(
          this.userInfo.openid + "-expressTosend-paotuiCancel",
          function (_id) {
            // 处于待取件页签才需要响应
            if (that.statusType == "ing") {
              for (let i = 0; i < that.expresses.length; i++) {
                if (that.expresses[i]._id == _id) {
                  that.expresses[i].status = 0;
                  that.expresses[i].statusStr = "待取件";
                  that.expresses[i].paotuiOrderNo = "";
                }
              }
            }
          }
        );
        socket.on("agentRefuse", function (_id) {
          // 处于待取件页签才需要响应
          if (that.statusType == "ing") {
            for (let i = 0; i < that.expresses.length; i++) {
              if (that.expresses[i]._id == _id) {
                that.expresses[i].status = 0;
                that.expresses[i].statusStr = "待取件";
                that.expresses[i].agentId = "";
                that.expresses[i].agentOpenid = "";
                that.expresses[i].agent = "";
                that.expresses[i].agentPhone = "";
                that.expresses[i].agentQrimgBase64 = "";
              }
            }
          }
        });
        socket.on(this.userInfo.openid + "-agentCancel", function (_id) {
          // 处于待取件页签才需要响应
          if (that.statusType == "ing") {
            for (let i = 0; i < that.expresses.length; i++) {
              if (that.expresses[i]._id == _id) {
                that.expresses.splice(i, 1);
              }
            }
            if (that.expresses.length == 0) {
              that.haveData = false;
            }
          }
        });
      })
      .catch((error) => {
        this.haveData = false;
        weui.topTips("获取用户信息失败", 2000);
      });
  },
  methods: {
    loadMore() {
      if (this.isScrollEnd || this.isScrollBusy) {
        return;
      }
      this.isScrollBusy = true;
      this.pageNo = this.pageNo + 1;
      let params = {
        statusStr: this.statusType,
        pageNo: this.pageNo,
      };
      setTimeout(() => {
        axios
          .get("/api/expressTosend/pagingForFontend", { params })
          .then((res) => {
            this.isScrollBusy = false;
            if (res.data.success) {
              this.pageCount = res.data.data.pageCount;
              this.recordCount = res.data.data.recordCount;
              if (this.pageCount > 0) {
                this.haveData = true;
              } else {
                this.haveData = false;
              }

              if (res.data.data.pageNumber >= this.pageCount) {
                this.isScrollEnd = true;
              } else {
                this.isScrollEnd = false;
              }

              let tempArray = res.data.data.results;
              let currOpenid = this.userInfo.openid;
              let targetArray = tempArray.map((item) => {
                if (item.status == 1) {
                  if (currOpenid == item.receiverOpenid) {
                    item.qrcode = "data:image/png;base64," + item.qrimgBase64;
                  } else if (currOpenid == item.agentOpenid) {
                    item.qrcode =
                      "data:image/png;base64," + item.agentQrimgBase64;
                  }
                } else {
                  item.qrcode = "data:image/png;base64," + item.qrimgBase64;
                }
                item.inTime = moment(item.createdAt).format("YYYY-MM-DD HH:mm");
                if (item.safekeepNeedPay && !item.isPayed) {
                  item.statusStr = "待支付";
                } else if (item.status == 0) {
                  item.statusStr = "待取件";
                } else if (item.status == 1) {
                  item.statusStr = "朋友代取";
                } else if (item.status == 2) {
                  item.statusStr = "待支付";
                } else if (item.status == 3) {
                  item.statusStr = "待接单";
                } else if (item.status == 4) {
                  item.statusStr = "已领任务";
                } else if (item.status == 5) {
                  item.statusStr = "已领货";
                } else if (item.status == 6) {
                  item.statusStr = "已送达";
                } else if (item.status == 100) {
                  item.statusStr = "已签收";
                } else if (item.status == 300) {
                  item.statusStr = "待退送";
                } else if (item.status == 400) {
                  item.statusStr = "已退送";
                }

                // 大小
                if (!item.size || item.size == 1) {
                  item.sizeStr = "小件";
                } else if (item.size == 2) {
                  item.sizeStr = "中件";
                } else if (item.size == 3) {
                  item.sizeStr = "大件";
                } else if (item.size == 4) {
                  item.sizeStr = "超大件";
                }
                return item;
              });

              for (let i = 0; i < targetArray.length; i++) {
                this.expresses.push(targetArray[i]);
              }
            } else {
              this.haveData = false;
              weui.topTips("获取快递列表出错", 1500);
            }
          })
          .catch((err) => {
            this.isScrollBusy = false;
            console.log(err);
            weui.topTips("获取快递列表出错", 1500);
          });
      }, 500);
    },
    toggleType(type) {
      if (this.statusType != type) {
        this.statusType = type;
        this.pageNo = 0;
        this.pageCount = 0;
        this.isScrollEnd = false;
        this.expresses = [];
        this.haveData = true;
        this.loadMore();
      }
    },
    showImagePreview(img) {
      this.imgs = [img];
      this.imgPreivew = this.$createImagePreview({
        imgs: this.imgs,
      });
      this.imgPreivew.show();
    },
    openBox(expressId) {
      axios
        .get("/api/box/openFromWX/" + expressId)
        .then((res) => {
          if (res.data.success) {
            if (res.data.data) {
              let prepayId = res.data.data;
              // 获取支付签名
              let params = {
                package: prepayId,
              };

              axios
                .get("/api/wx/paysign", { params })
                .then((response) => {
                  if (response.data.success) {
                    let payConfig = response.data.data;
                    wx.chooseWXPay(payConfig);
                  } else {
                    weui.alert("获取支付签名失败");
                  }
                })
                .catch((error) => {
                  weui.alert("获取支付签名失败");
                });
            }
          } else {
            weui.alert(res.data.message);
          }
        })
        .catch((err) => { });
    },
    daiqu(_id) {
      this.$router.push("/proxyGet/" + _id + "/" + this.encodeToken);
    },
    songhuo(_id) {
      // 判断时间，如果已经超过营业时间，则提示快递服务中心今天已关门，请明天再来
      let nowTime = moment().valueOf();
      let endTimeStr = "";
      let endTime = 0;
      if (this.userInfo.worksite.paotuiOrderLastTime) {
        endTimeStr =
          moment().format("YYYY-MM-DD") +
          " " +
          this.userInfo.worksite.paotuiOrderLastTime +
          ":00";
        endTime = moment(endTimeStr).valueOf();
      } else {
        endTimeStr =
          moment().format("YYYY-MM-DD") +
          " " +
          this.userInfo.worksite.serviceEnd +
          ":00";
        endTime = moment(endTimeStr).subtract(30, "m").valueOf();
      }
      if (nowTime > endTime) {
        if (this.userInfo.worksite.paotuiOrderLastTime) {
          weui.alert(
            "代拿下单截止时间 " +
            moment(endTimeStr).format("HH:mm") +
            "，如需送件上门，请明天再预约。"
          );
        } else {
          weui.alert(
            "代拿下单截止时间 " +
            moment(endTimeStr).subtract(30, "m").format("HH:mm") +
            "，如需送件上门，请明天再预约。"
          );
        }
        return;
      } else {
        this.$router.push("/doorService/" + _id + "/" + this.encodeToken);
      }
    },
    yiqu(_id) {
      let that = this;
      weui.confirm(
        "确定已取？",
        function () {
          axios
            .put("/api/expressTosend/takepartBySelf/" + _id)
            .then((res) => {
              if (res.data.success) {
                weui.toast("已签收", 1000);
                for (let i = 0; i < that.expresses.length; i++) {
                  if (that.expresses[i]._id == _id) {
                    that.expresses.splice(i, 1);
                    if (that.imgPreivew) {
                      that.imgPreivew.hide();
                    }
                    break;
                  }
                }
                if (that.expresses.length == 0) {
                  that.haveData = false;
                }
              } else {
                setTimeout(function () {
                  weui.alert("签收失败");
                }, 500);
              }
            })
            .catch((err) => {
              setTimeout(function () {
                weui.alert("签收失败");
              }, 500);
            });
        },
        function () { }
      );
    },
    qianshou(_id, orderNo) {
      let that = this;
      weui.confirm(
        "确定已收到快递？",
        function () {
          axios
            .put("/api/paotuiOrder/receiverSignByOrderNoRollModule/" + orderNo)
            .then((res) => {
              if (res.data.success) {
                weui.toast("已签收", 1000);
                // 跳转到跑腿完成页面，方便用户进行评价
                // that.$router.push("/robbingList/1/complete/" + that.encodeToken);
                // 跳转到评价页面
                that.$router.push(
                  "/comment/" +
                  item._id +
                  "/" +
                  item.acceptOpenid +
                  "/" +
                  encodeURIComponent(item.acceptUser) +
                  "/" +
                  encodeURIComponent(item.realArriveTime) +
                  "/" +
                  that.encodeToken
                );
              } else {
                setTimeout(function () {
                  weui.alert("签收失败");
                }, 500);
              }
            })
            .catch((err) => {
              setTimeout(function () {
                weui.alert("签收失败");
              }, 500);
            });
        },
        function () { }
      );
    },
    jujue(item) {
      let that = this;
      weui.confirm(
        "确定拒绝该代取？",
        function () {
          axios
            .put("/api/expressTosend/proxy/refuseAgent/" + item._id)
            .then((res) => {
              if (res.data.success) {
                weui.toast("拒绝代取成功", 1000);
                for (let i = 0; i < that.expresses.length; i++) {
                  if (that.expresses[i]._id == item._id) {
                    that.expresses.splice(i, 1);
                  }
                }
                if (that.expresses.length == 0) {
                  that.haveData = false;
                }
              } else {
                weui.alert(res.data.message);
              }
            })
            .catch((err) => {
              weui.alert("拒绝代取失败");
            });
        },
        function () {
          console.log("no");
        }
      );
    },
    quxiao(item) {
      let that = this;
      weui.confirm(
        "确定取消该代取？",
        function () {
          axios
            .put("/api/expressTosend/proxy/cancelAgent/" + item._id)
            .then((res) => {
              if (res.data.success) {
                weui.toast("取消代取成功", 1000);
                item.status = 0;
                item.statusStr = "待取件";
                delete item.agent;
                delete item.agentPhone;
                delete item.agentOpenid;
              } else {
                weui.alert(res.data.message);
              }
            })
            .catch((err) => {
              weui.alert("取消代取失败");
            });
        },
        function () {
          console.log("no");
        }
      );
    },
    goPay(item) {
      // 生成prepayId并调用支付
      axios
        .get("/api/expressTosend/paysafekeep/" + item._id)
        .then((response) => {
          if (response.data.success) {
            let payConfig = response.data.data;
            payConfig.success = function (res) {
              // 改变当前记录状态
              item.isPayed = true;
              item.statusStr = "待取件";
            };
            wx.chooseWXPay(payConfig);
          } else {
            weui.alert("获取支付签名失败");
          }
        })
        .catch((error) => {
          weui.alert("获取支付签名失败");
        });
    },
    zhifu(item) {
      let that = this;
      axios
        .get("/api/paotuiOrder/getByOrderNo/" + item.paotuiOrderNo)
        .then((res) => {
          let prepayId = res.data.data.prepayId;
          // 获取支付签名
          let params = {
            package: prepayId,
          };

          axios
            .get("/api/wx/paysign", { params })
            .then((response) => {
              if (response.data.success) {
                let payConfig = response.data.data;
                payConfig.success = function (res) {
                  // 改变当前记录状态
                  item.status = 3;
                  item.statusStr = "待接单";
                };
                wx.chooseWXPay(payConfig);
              } else {
                weui.alert("获取支付签名失败");
              }
            })
            .catch((error) => {
              weui.alert("获取支付签名失败");
            });
        })
        .catch((err) => { });
    },
    gotoPaotui() {
      this.$router.push("/robbingList/1/ing/" + this.encodeToken);
    },
    quxiaopaotui(item) {
      weui.confirm(
        "确定取消该任务？",
        function () {
          axios
            .put("/api/paotuiOrder/cancel/" + item.paotuiOrderNo)
            .then((res) => {
              if (res.data.success) {
                weui.toast("取消成功", 1000);
                item.status = 0;
                item.statusStr = "待取件";
              } else {
                setTimeout(function () {
                  weui.alert("取消任务失败");
                }, 500);
              }
            })
            .catch((err) => {
              setTimeout(function () {
                weui.alert("取消任务失败");
              }, 500);
            });
        },
        function () { }
      );
    },
  },
  mounted() {
    this.loadMore();
  },
};
</script>
<style scoped>
.empty-data {
  text-align: center;
  margin-top: 50px;
}

.empty-data div i {
  font-size: 120px;
  color: #cccccc;
}

.empty-data div p {
  font-size: 30px;
  color: #cccccc;
}

.collgoods {
  font-size: 14px;
  margin: 0 auto;
  text-align: center;
}

.collgoods header {
  padding-left: 15px;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #eee;
  color: #fff;
  background-color: #1aad19;
  position: relative;
}

.collgoods-item {
  margin: 15px;
  border: 1px solid #1aad19;
}

.collgoods-item+.collgoods-item {
  margin-top: 10px;
}

.collgoods-item-top {
  display: flex;
  height: 36px;
  line-height: 36px;
  border-bottom: 1px solid #eee;
}

.collgoods-item-top>div {
  flex: 1;
}

.item-top-left {
  padding-left: 10px;
  text-align: left;
  color: orange;
}

.item-top-left span {
  font-weight: bold;
  font-size: 15px;
}

.item-top-right {
  padding-right: 10px;
  text-align: right;
}

.item-top-right a {
  display: inline;
  font-size: 12px;
  border-radius: 5px;
  border: 1px solid orange;
  color: orange;
  padding: 2px 3px;
}

.item-top-right span {
  display: inline;
  font-size: 12px;
  border-radius: 5px;
  border: 1px solid orangered;
  color: orangered;
  padding: 2px 4px;
  margin-right: 10px;
}

.collgoods-item-middle {
  display: flex;
  padding-top: 3px;
  padding-bottom: 3px;
  border-bottom: 1px solid #eee;
}

.item-middle-left {
  text-align: left;
  padding-left: 10px;
  flex: 1;
  font-size: 13px;
}

.item-middle-left_title {
  font-weight: bold;
  color: #1aad19;
}

.password {
  background-color: #aaaaaa;
  color: #ffffff;
  font-size: 12px;
  padding: 2px;
  margin-right: 1px;
}

.password:last-child {
  margin-right: 0px;
}

.item-middle-left p {
  padding: 5px;
}

.item-middle-right {
  display: flex;
  justify-content: flex-end;
  padding-right: 5px;
  display: flex;
  align-items: center;
}

.item-middle-right img {
  width: 100px;
  height: 100px;
  display: inline-block;
}

.item-middle-right img.big-qr {
  width: 180px;
  height: 180px;
  display: inline-block;
}

.open-bnt {
  background-color: orangered;
  color: #ffffff;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px 5px 10px 0px;
  padding: 25px;
}

.collgoods-item-bottom {
  min-height: 40px;
  line-height: 40px;
  margin-right: 10px;
}

.collgoods-item-bottom-left {
  padding-left: 10px;
  float: left;
  color: orangered;
}

.collgoods-item-bottom-left span {
  font-weight: bold;
  font-size: 15px;
}

.collgoods-item-bottom-right {
  float: right;
}

.collgoods-item-bottom a {
  display: inline;
  padding: 4px 10px;
  margin-left: 10px;
  color: white;
}

.collgoods-item-bottom a.yiqu {
  background-color: #1aad19;
}

.collgoods-item-bottom a.daiqu {
  background-color: rgb(255, 152, 0);
}

.collgoods-item-bottom a.songhuo {
  background-color: orangered;
}

.collgoods-item-bottom a.zhifu {
  background-color: #1aad19;
}

.collgoods-item-bottom a.disable {
  background-color: grey;
}

.weui-footer {
  position: fixed;
  bottom: 10px;
  left: 0px;
  right: 0px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}

.robbing-nav {
  display: flex;
  height: 50px;
  line-height: 50px;
  font-weight: bold;
}

.robbing-nav-item {
  flex: 1;
  font-weight: bold;
  border-bottom: 1px solid #eee;
  border-right: 1px solid #eee;
}

.robbing-nav-item:last-child {
  border-right: none;
}

.robbing-nav-item.select {
  color: red;
  border-bottom: 1px solid red;
}

.mail-tips {
  text-align: left;
  padding: 10px;
  padding-left: 15px;
  background-color: lightyellow;
}
</style>


// WEBPACK FOOTER //
// src/components/ExpressTotakeList.vue